import { Component, OnInit, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core'
import ReactDOM from 'react-dom'
import React from 'react'
import { Loader } from '@dfds-ui/react-components'
import { CookieService } from '../cookie.service'
import styled from '@emotion/styled'

@Component({
    selector: "sbw-loader",
    template: '<div #react></div>',
})
export class LoaderComponent implements OnInit {
    @ViewChild("react", { static: true }) react: ElementRef;

    @Input() label: string

    constructor(
        private cookieService: CookieService
    ) { }

    ngOnInit() {
        this.render()
    }

    private render() {

        const StyledWrapper = styled.div`
            opacity: ${this.cookieService.getCookie('e2e_overlay_transparent') ? 0.9 : 1 };
        `

        ReactDOM.render(
            <StyledWrapper>
                <Loader label={this.label}
                />
            </StyledWrapper>,
                this.react.nativeElement
        );
    }
}
